module.exports = __webpack_public_path__ + "static/flex2-009d4b5f5d409b7ab713be9e4165f675.png";